import { Button } from 'antd'
import React, { useCallback } from 'react'
import styles from './InsituPointPopup.module.scss'
import { DateFormat } from '../../../../../utils/StaticVariable'
import moment from 'moment'

interface IInsituPointPopup {
    coordinates: number[]
    name: string
    source: string
    type: string
    timePeriod: {
        startDate: string,
        endDate: string
    },
    loadingDelete: boolean,
    createNewPoint: (coordinates: Array<number>, fwePointName?: undefined, insituPointName?: string) => void;
    handleClose: () => void
    setConfirmationDeletePopup: (item: boolean) => void
    setLoadingDelete: (item: boolean) => void
}

const InsituPointPopup: React.FC<IInsituPointPopup> = ({
    coordinates,
    name,
    source,
    timePeriod,
    loadingDelete,
    type,
    createNewPoint,
    handleClose,
    setLoadingDelete,
    setConfirmationDeletePopup,
}) => {

  const handleCreateNewPoint = useCallback(() => {
    createNewPoint(coordinates, undefined, name);
    handleClose();
  }, [coordinates, name, createNewPoint, handleClose]);

  const handleConfirmDelete = useCallback(async () => {
    try {
      setLoadingDelete(true)
      setConfirmationDeletePopup(true);
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingDelete(false)
    }
  }, [name]);

    return (
        <div className={styles.container}>
            <div className={styles.title}><b>{name}</b></div>
            <div className={styles.coordinates}>
                <div>Long {Math.round(coordinates[0] * 10000) / 10000}</div>
                <div className={styles.leftPadding}>Lat {Math.round(coordinates[1] * 10000) / 10000}</div>
            </div>
            <div className={styles.source}>
                <div>Source: {source}</div>
            </div>
            <div>
                <div>
                    Time Period: {moment(timePeriod.startDate).format(DateFormat)} - {moment(timePeriod.endDate).format(DateFormat)}
                </div>
            </div>
            <div className={styles.buttonWrapper}>
              {type === 'mood' && (
                <Button
                  type="default"
                  onClick={handleConfirmDelete}
                  className={styles.buttonDelete}
                  loading={loadingDelete}
                >
                  {loadingDelete ? 'Removing...' : 'Remove dataset from MOOD'}
                </Button>
              )}
              <Button
                type="primary"
                onClick={handleCreateNewPoint}
                className={styles.button}
              >
                New point in this location
              </Button>
            </div>
        </div>
    )
}

export default InsituPointPopup
